/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_I18nInputs */

const en_svchip_i18n = /** @type {(inputs: Svchip_I18nInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`i18n`)
};

const ar_svchip_i18n = /** @type {(inputs: Svchip_I18nInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`التدويل`)
};

const bn_svchip_i18n = /** @type {(inputs: Svchip_I18nInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`i18n`)
};

const de_svchip_i18n = /** @type {(inputs: Svchip_I18nInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`i18n`)
};

const es_svchip_i18n = /** @type {(inputs: Svchip_I18nInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`i18n`)
};

const fr_svchip_i18n = /** @type {(inputs: Svchip_I18nInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`i18n`)
};

const pt_svchip_i18n = /** @type {(inputs: Svchip_I18nInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`i18n`)
};

const zh_svchip_i18n = /** @type {(inputs: Svchip_I18nInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`i18n`)
};

const tr_svchip_i18n = /** @type {(inputs: Svchip_I18nInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`i18n`)
};

const ru_svchip_i18n = /** @type {(inputs: Svchip_I18nInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`i18n`)
};

const pl_svchip_i18n = /** @type {(inputs: Svchip_I18nInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`i18n`)
};

/**
* | output |
* | --- |
* | "i18n" |
*
* @param {Svchip_I18nInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_i18n = /** @type {((inputs?: Svchip_I18nInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_I18nInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_i18n(inputs)
	if (locale === "bn") return bn_svchip_i18n(inputs)
	if (locale === "de") return de_svchip_i18n(inputs)
	if (locale === "es") return es_svchip_i18n(inputs)
	if (locale === "fr") return fr_svchip_i18n(inputs)
	if (locale === "pt") return pt_svchip_i18n(inputs)
	if (locale === "zh") return zh_svchip_i18n(inputs)
	if (locale === "tr") return tr_svchip_i18n(inputs)
	if (locale === "ru") return ru_svchip_i18n(inputs)
	if (locale === "pl") return pl_svchip_i18n(inputs)
	return en_svchip_i18n(inputs)
});